import { useEffect, useRef } from 'react';
import { tsr } from '../../lib/api.js';
import { createWebPhoneVerifier, PhoneVerificationError } from '../../lib/phoneVerification.js';
import { servePhoneVerification } from '../../lib/phoneVerifyFrameHost.js';

/**
 * `app.<domain>/phone-verify` — the hidden frame a company subdomain sends its SMS code through
 * (`lib/phoneVerifyFrame.ts`). main.tsx renders it alone: no session, no shell, nothing visible
 * except a reCAPTCHA puzzle when Google asks for one.
 */
export function PhoneVerifyFrame() {
  const recaptchaRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Transparent and in the same colour scheme as the iframe element, so an open puzzle floats
    // over the company page instead of blanking it.
    const html = document.documentElement;
    html.style.colorScheme = 'light';
    html.style.background = 'transparent';
    document.body.style.background = 'transparent';

    return servePhoneVerification({
      async createVerifier() {
        const res = await tsr.auth.signupOptions.query();
        const config = res.status === 200 ? res.body.phoneVerification : null;
        if (!config) throw new PhoneVerificationError('unavailable');
        return createWebPhoneVerifier(config, recaptchaRef.current!);
      },
    });
  }, []);

  return <div ref={recaptchaRef} />;
}
